import { Outlet, NavLink } from 'react-router-dom'

const navItems = [
  { to: '/day',      label: 'Today',    icon: '🍽' },
  { to: '/log',      label: 'Log food', icon: '➕' },
  { to: '/progress', label: 'Progress', icon: '📈' },
  { to: '/profile',  label: 'Profile',  icon: '👤' },
]

export default function Layout() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      <main style={{ flex: 1, overflowY: 'auto', paddingBottom: '4rem' }}>
        <Outlet />
      </main>

      <nav
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          borderTop: '1px solid #27272a',
          background: '#18181b',
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
        {navItems.map(({ to, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            style={({ isActive }) => ({
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '0.5rem 0',
              textDecoration: 'none',
              fontSize: '0.7rem',
              color: isActive ? '#22d3ee' : '#71717a',
              gap: '2px',
            })}
          >
            <span style={{ fontSize: '1.25rem' }}>{icon}</span>
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
